module.exports = __webpack_public_path__ + "media/images/menu/channel_4_on-de713b33dbccca3e25befae1257cd066.jpg";